<template>
  <delivery-search :is-delivery-estimate="true" />
</template>

<script lang="ts">
import DeliverySearch from './DeliverySearch.vue';

export default {
  name: 'DeliveryEstimate',

  components: {
    DeliverySearch,
  },

  setup: () => {
    return {};
  },
};
</script>
